import settings from "app/settings"

export const FETCH_STARTED = "FETCH_STARTED"
export const FETCH_COMPLETED = "FETCH_COMPLETED"

export function fetchWithAuth(url, params) {
    if (!params)
        params = {
            method: "GET",
        }
    // url = url.includes("?") ? url + "&" : url + "?"
    let stack_id = localStorage.getItem("stack_id")
    let api_token = localStorage.getItem("user_token") || localStorage.getItem("studio_token")
    // url = url + "api_token=" + api_token
    var headers = new Headers({
        ...params.headers,
        "X-Api-Token": api_token,
        "X-Stack-Id": stack_id,
    })

    params = { ...params, headers }
    //new Headers
    return fetch(settings.API_ROOT + url, params)
}

export const acceptHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
}

export const fetchAndReturn = (url, params, process) => {
    if (!process) process = string => string.json()
    return fetchWithAuth(url, params).then(response => {
        if (response.status >= 400) {
            return Promise.reject(response)
        }
        return response.json()
    })
}

export class StackerAPI {
    preprocessFromLocal = data => {
        var out = data
        if (this.transformFromLocal) {
            out = this.transformFromLocal(data)
        }
        return JSON.stringify(out)
    }
    preprocessToLocal = data => {
        var received = data
        if (this.transformToLocal) {
            received = Array.isArray(received)
                ? received.map(this.transformToLocal)
                : this.transformToLocal(received)
        }
        return received
    }

    path = ""
    get(id) {
        const path = this.path + (id ? `${id}/` : ``)
        return fetchAndReturn(path, {}, this.preprocessToLocal)
    }
    post(data) {
        return fetchAndReturn(this.path, {
            method: "POST",
            headers: acceptHeaders,
            body: this.preprocessFromLocal(data),
        })
    }
    delete(id) {
        return fetchAndReturn(this.path + id + "/", { method: "DELETE" })
    }
    patch(id, data) {
        return fetchAndReturn(this.path + id + "/", {
            method: "PATCH",
            headers: acceptHeaders,
            body: this.preprocessFromLocal(data),
        })
    }
}

export class StackerActions {
    actionTypes = { fetched: null, removed: null, created: null, updated: null }
    api = null
    reducer = null
    fetch = id => {
        return (dispatch, getState) => {
            // Don't need to get it if we've already got it
            if (getState()[this.reducer].entities[id]) return

            // Let's make sure we're not sending multiple request for the same thing
            let fetchKey = this.actionTypes.fetched + id
            if (getState()[this.reducer].fetching.indexOf(fetchKey) !== -1) return
            dispatch({ type: FETCH_STARTED, key: fetchKey })
            this.api.get(id).then(
                this.processFetch ||
                    (response => {
                        dispatch({ type: FETCH_COMPLETED, key: fetchKey })
                        return dispatch({
                            type: this.actionTypes.fetched,
                            payload: response,
                            id,
                        })
                    }),
                error => {
                    console.error("failed to fetch", error)
                }
            )
            this.afterFetch && this.afterFetch(dispatch)
        }
    }
    create = data => {
        return dispatch => {
            return this.api.post(data).then(
                this.processCreate ||
                    (response => {
                        dispatch({ type: this.actionTypes.created, payload: response })
                        return response
                    })
            )
        }
    }
    update = (id, data) => {
        return dispatch => {
            dispatch({ type: this.actionTypes.updated, id: id, payload: data })
            return this.api.patch(id, data).then(
                this.processUpdate ||
                    (response => {
                        dispatch({
                            type: this.actionTypes.updated,
                            id: id,
                            payload: response,
                        })
                        return response
                    })
            )
        }
    }
    remove = id => {
        return dispatch => {
            this.api.delete(id).then(
                this.processUpdate ||
                    (() => {
                        return dispatch({ type: this.actionTypes.removed, id: id })
                    })
            )
        }
    }

    actions = {
        fetch: this.fetch,
        update: this.update,
        create: this.create,
        remove: this.remove,
    }
}

export const byID = (dict, field = "_sid") => {
    if (typeof dict.reduce !== "function") return {}
    return dict.reduce((current, item) => ({ ...current, [item[field]]: item }), {})
}

export const without = (array, value) => {
    const index = array.indexOf(value)
    if (index > -1) {
        return array.slice(index, 1)
    }
    return array
}



// WEBPACK FOOTER //
// ./src/data/utils/utils.js